var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandMore = function SvgExpandMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.88 9.29 12 13.17 8.12 9.29a.996.996 0 1 0-1.41 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.39-1.42 0"
  })));
};
export { SvgExpandMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTUuODggOS4yOUwxMiAxMy4xN0w4LjEyMDAxIDkuMjlDNy43MzAwMSA4LjkgNy4xMDAwMSA4LjkgNi43MTAwMSA5LjI5QzYuMzIwMDEgOS42OCA2LjMyMDAxIDEwLjMxIDYuNzEwMDEgMTAuN0wxMS4zIDE1LjI5QzExLjY5IDE1LjY4IDEyLjMyIDE1LjY4IDEyLjcxIDE1LjI5TDE3LjMgMTAuN0MxNy42OSAxMC4zMSAxNy42OSA5LjY4IDE3LjMgOS4yOUMxNi45MSA4LjkxIDE2LjI3IDguOSAxNS44OCA5LjI5VjkuMjlaIi8+PC9zdmc+";